// extracted by mini-css-extract-plugin
module.exports = {"Main":"Setup_Main__o-3pr","Main_loading":"Setup_Main_loading__3Jwnl","Modal":"Setup_Modal__32WOy","Content":"Setup_Content__a6Yoo","Link":"Setup_Link__13mNQ"};